import { getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'

import { graphqlToForm } from '@/features/translations'
import { initFields as initDefaultFields } from '../components/fields/DefaultFields'
import { initFields as initEventFields } from '../components/fields/EventFields'
import { TRANSLATABLE_FIELDS, type FormData } from '../hooks/useGoodieForm'

export function generateDefaults({
  type,
  goodie,
  supportedLocales
}: {
  type: GraphQL.GoodieType
  goodie?: GraphQL.GoodieFragmentFragment
  supportedLocales: GraphQL.AppLocale[]
}): FormData {
  return {
    default:
      type === GraphQL.GoodieType.Default ? initDefaultFields(goodie) : null,
    event:
      type === GraphQL.GoodieType.Event ? initEventFields(goodie) : undefined,
    message:
      type === GraphQL.GoodieType.Message
        ? {
            toBeReplaced: false
          }
        : null,
    description: goodie?.description ?? '',
    title: goodie?.title ?? '',
    name: goodie?.name ?? '',
    files:
      goodie?.gallery?.map(function (fileFragment) {
        return getFragment(SharedAPI.file.FILE_FRAGMENT, fileFragment)
      }) ?? [],
    type,
    integrationDoorId: goodie?.integrationDoorId ?? null,
    translations: graphqlToForm(
      (goodie?.translations ?? []).flatMap(trans =>
        getFragment(SharedAPI.translation.TRANSLATION_FRAGMENT, trans)
      ),
      TRANSLATABLE_FIELDS,
      supportedLocales
    )
  } as FormData
}
